import Vue from 'vue';
import Vuex from 'vuex';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Auth: null,
    isMobile: false,
    dialogOptions: null,
  },
  getters: {
    user(state) {
      return state.Auth;
    },
    isMobile(state) {
      return state.isMobile;
    },
    generalDialogOptions(state): MiDialogOptions | null {
      return state.dialogOptions;
    },
    currentUser(state) {
      return state.Auth;
    },
    isBureau(state) {
      return state.Auth && (state.Auth as any).hasHinType('bureau');
    },
    isContractor(state) {
      return state.Auth && (state.Auth as any).hasHinType('contractor');
    },
  },
  mutations: {
    USER_AUTHENTICATED: (state, payload) => {
      state.Auth = payload;
    },
    USER_DEAUTHENTICATED: (state, payload) => {
      if (state.Auth !== null && state.Auth !== undefined) {
        (state.Auth as any).logout();
      } else {
        window.location.href = '/';
      }

      state.Auth = null;
    },
    DIALOG_OPENED: (state: any, options: MiDialogOptions) => {
      state.dialogOptions = options;
    },
    DIALOG_CLOSED: (state: any, options: null) => {
      state.dialogOptions = null;
    },
  },
  actions: {
    ensureUserLoaded: ({ dispatch, getters }) => dispatch('userAuthenticated', getters.currentUser),
    userAuthenticated: (context, payload) => {
      context.commit('USER_AUTHENTICATED', payload);
    },
    userDeauthenticated: (context, payload) => {
      context.commit('USER_DEAUTHENTICATED', payload);
    },
    openDialog: (context: any, options: MiDialogOptions) => {
      context.commit('DIALOG_OPENED', options);
    },
    closeDialog: (context: any, options = null) => {
      context.commit('DIALOG_CLOSED', options);
    },
  },
  modules: {
  },
});
